import React, { useState, useEffect } from 'react';
import { productsAPI, categoriesAPI } from '../utils/api';
import Sidebar from '../components/Sidebar';
import ProductCard from '../components/ProductCard';
import { FaSearch, FaSort } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import '../styles/Catalog.css';

const Catalog = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { t } = useTranslation();

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    loadCategories();
  }, []);

  useEffect(() => {
    loadProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory, selectedSubCategory, searchQuery, sortBy]);

  const loadCategories = async () => {
    try {
      const response = await categoriesAPI.getCategories();
      setCategories(response.data.data);
    } catch (error) {
      console.error('Ошибка загрузки категорий:', error);
    }
  };

  const loadProducts = async () => {
    setLoading(true);
    setError('');
    
    try {
      const params = {
        isActive: true,
        inStock: true, // Для пользователей показываем только товары в наличии
        sortBy
      };

      if (selectedCategory) params.category = selectedCategory;
      if (selectedSubCategory) params.subCategory = selectedSubCategory;
      if (searchQuery) params.search = searchQuery;

      const response = await productsAPI.getProducts(params);
      
      // Сортируем: продукты со скидками первыми
      const sortedProducts = response.data.data.sort((a, b) => {
        const aHasDiscount = ((a.personalDiscount?.value || 0) > 0 || (a.generalDiscountType !== 'none' && (a.generalDiscountValue || 0) > 0)) && a.finalPrice < a.price;
        const bHasDiscount = ((b.personalDiscount?.value || 0) > 0 || (b.generalDiscountType !== 'none' && (b.generalDiscountValue || 0) > 0)) && b.finalPrice < b.price;
        if (aHasDiscount && !bHasDiscount) return -1;
        if (!aHasDiscount && bHasDiscount) return 1;
        return 0;
      });

      setProducts(sortedProducts);
    } catch (error) {
      console.error('Tellimuste laadimine ebaõnnestus:', error);
      setError(t('errorLoadingProducts', 'Toodete laadimine ebaõnnestus'));
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSortChange = (e) => {
    setSortBy(e.target.value);
  };

  return (
    <div className="catalog-page">
      <Sidebar
        categories={categories}
        selectedCategory={selectedCategory}
        selectedSubCategory={selectedSubCategory}
        onSelectCategory={setSelectedCategory}
        onSelectSubCategory={setSelectedSubCategory}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />

      <div className="catalog-content">
        <div className="catalog-header">
          <h1>{t('productCatalog')}</h1>
          
          <div className="catalog-controls">
            <div className="search-box">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder={t('searchProducts')}
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>

            <div className="sort-box">
              <FaSort className="sort-icon" />
              <select value={sortBy} onChange={handleSortChange}>
                <option value="name">{t('sortByName')}</option>
                <option value="price-asc">{t('sortByPriceAsc')}</option>
                <option value="price-desc">{t('sortByPriceDesc')}</option>
                <option value="popularity">{t('sortByPopularity')}</option>
              </select>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
            <p>{t('loadingProducts')}</p>
          </div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : products.length === 0 ? (
          <div className="no-products">
            <p>{t('noProductsFound')}</p>
          </div>
        ) : (
          <div className="products-grid">
            {products.map((product) => (
              <ProductCard key={product._id} product={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Catalog;

